import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import StarIcon from '@material-ui/icons/Star'
import StarOutlineIcon from '@material-ui/icons/StarOutline'
import { Rating } from '@material-ui/lab'
import Alert from '@material-ui/lab/Alert'
import format from 'date-fns/format'
import React, { useContext, useState } from 'react'

import colorContext from '../../Context/colorContext'
import evaluationMain from '../../services/avaliacao'
import getCookie from '../../utils/getCookies'
import { UserData } from '../AttendenceOnline'
import { useStyles } from './styles'

interface Props {
  onPermittedCloseModal: () => void
  setEvaluationCompleted: React.Dispatch<React.SetStateAction<boolean>>
  setHiddenWarning: React.Dispatch<React.SetStateAction<boolean>>
  evaluationCompleted: boolean
  serviceSelected: any
  tipoAvaliacao:
    | 'Agendamento'
    | 'Formflow'
    | 'Solicitação'
    | 'Manifestação'
    | 'Esic'
  selectedDate?: Date | null
  scheduleSelected?: string
  onGoToHome?: () => void
  onGoToSchedules?: () => void
  onClose?: () => void
}

export default function SchedulingAssessment({
  setEvaluationCompleted,
  evaluationCompleted,
  serviceSelected,
  tipoAvaliacao,
  setHiddenWarning,
  selectedDate,
  scheduleSelected,
  onGoToHome,
  onGoToSchedules,
  onClose,
}: Props): JSX.Element {
  const [description, setDescription] = useState<string | null>('')
  const [descriptionPlatform, setDescriptionPlatform] = useState<string | null>(
    '',
  )
  const [ratingPlatform, setRatingPlatform] = React.useState<number>(5)
  const [ratingScheduling, setRatingScheduling] = React.useState<number>(5)
  const [loading, setLoading] = useState<boolean>(false)
  const { colors } = useContext(colorContext)
  const classes = useStyles({ colors })

  const handleRatingPlatform = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRatingPlatform(parseFloat(e.target.value))
  }
  const handleRatingScheduling = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRatingScheduling(parseFloat(e.target.value))
  }

  const sendEvaluation = async (): Promise<void> => {
    setLoading(true)
    setHiddenWarning(true)
    const token: string | null = getCookie('gov_access_token_sso')
    const dataStorage: string | null = getCookie('gov_user_data')
    const userData: UserData | null = dataStorage
      ? JSON.parse(dataStorage)
      : null
    if (token && userData) {
      const avaliacao = {
        tipo: tipoAvaliacao,
        avaliacao_processo: ratingScheduling,
        comentario_processo: description,
        avaliacao_plataforma: ratingPlatform,
        comentario_plataforma: descriptionPlatform,
        servico: serviceSelected.id,
        orgao: null,
        token,
      }
      try {
        await evaluationMain(avaliacao)
        setEvaluationCompleted(false)
      } catch (err) {
        setLoading(false)
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <>
      {loading ? (
        <Box style={{ marginTop: 20, textAlign: 'center' }}>
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <Box className={classes.evaluationFormContainer}>
          {/* Botão de Fechar */}
          <IconButton onClick={onClose} className={classes.closeButton}>
            <CloseIcon style={{ width: 24, height: 24 }} />
          </IconButton>

          {/* Momento 1: Formulário de Avaliação */}
          {evaluationCompleted && (
            <>
              {/* Informações do Agendamento */}
              <Box className={classes.completedTitleGroup}>
                <Typography className={classes.completedScheduleTitle}>
                  Agendamento concluído!
                </Typography>
                <Typography className={classes.completedScheduleSubtitle}>
                  Enviamos para você um comprovante, verifique no seu e-mail.
                </Typography>
              </Box>

              <Box className={classes.completedInfoGroup}>
                {selectedDate && scheduleSelected && (
                  <Typography
                    className={classes.alertBoxDateTimeSchedule}
                    style={{ fontWeight: 600 }}
                  >
                    {typeof selectedDate?.getMonth === 'function' &&
                      format(selectedDate, 'dd/MM/yyyy')}{' '}
                    às {scheduleSelected}
                  </Typography>
                )}
                <Typography className={classes.completedScheduleSubtitle}>
                  Caso não possa comparecer, realizar o cancelamento do
                  agendamento no portal até 1h antes do horário previsto do
                  atendimento
                </Typography>
                <Alert severity="warning">
                  Não esqueça de levar os documentos solicitados no ato do
                  agendamento.
                </Alert>
              </Box>

              <Typography className={classes.mainEvaluationTitle}>
                Suas estrelas nos ajudam a melhorar nossos serviços!
              </Typography>

              {/* Avaliação do Agendamento */}
              <Box className={classes.evaluationAreaContainer}>
                <Typography className={classes.ratingTitle}>
                  Avalie seu agendamento!
                </Typography>
                <Box className={classes.ratingContainer}>
                  <Rating
                    id="rate-stars-scheduling"
                    size="large"
                    value={ratingScheduling}
                    onChange={handleRatingScheduling}
                    name="rating-scheduling"
                    icon={
                      <Box padding="10px">
                        <StarIcon className={classes.ratingStarIcon} />
                      </Box>
                    }
                    emptyIcon={
                      <Box padding="10px">
                        <StarOutlineIcon className={classes.ratingStarIcon} />
                      </Box>
                    }
                    style={{ marginBottom: 8 }}
                  />
                  <TextField
                    id="comment-scheduling"
                    placeholder={
                      ratingScheduling <= 3
                        ? 'Por favor, descreva o motivo da sua insatisfação ( Obrigatório )'
                        : 'Você gostaria de deixar um comentário? (Opcional)'
                    }
                    multiline
                    fullWidth
                    value={description}
                    onChange={(event) => setDescription(event.target.value)}
                    variant="outlined"
                    maxRows={2}
                    className={classes.textFieldCommentContainer}
                    inputProps={{
                      className: classes.textFieldCommentInput,
                    }}
                  />
                </Box>
              </Box>

              {/* Avaliação da Plataforma */}
              <Box className={classes.evaluationAreaContainer}>
                <Typography
                  className={classes.ratingTitle}
                  style={{ marginTop: 24 }}
                >
                  Avalie a Plataforma Salvador Digital
                </Typography>
                <Box className={classes.ratingContainer}>
                  <Rating
                    id="rate-stars-platform"
                    size="large"
                    value={ratingPlatform}
                    onChange={handleRatingPlatform}
                    name="rating-platform"
                    icon={
                      <Box padding="10px">
                        <StarIcon className={classes.ratingStarIcon} />
                      </Box>
                    }
                    emptyIcon={
                      <Box padding="10px">
                        <StarOutlineIcon className={classes.ratingStarIcon} />
                      </Box>
                    }
                    style={{ marginBottom: 8 }}
                  />
                  <TextField
                    id="comment-platform"
                    placeholder={
                      ratingPlatform <= 3
                        ? 'Por favor, descreva o motivo da sua insatisfação ( Obrigatório )'
                        : 'Você gostaria de deixar um comentário? (Opcional)'
                    }
                    multiline
                    fullWidth
                    value={descriptionPlatform}
                    onChange={(event) =>
                      setDescriptionPlatform(event.target.value)
                    }
                    variant="outlined"
                    maxRows={2}
                    className={classes.textFieldCommentContainer}
                    inputProps={{
                      className: classes.textFieldCommentInput,
                    }}
                  />
                </Box>
              </Box>

              {/* Botão Avaliar */}
              <Box className={classes.evaluateButtonContainer}>
                <Button
                  id="register-button"
                  disabled={
                    (ratingScheduling <= 3 && !description) ||
                    (ratingPlatform <= 3 && !descriptionPlatform)
                  }
                  onClick={sendEvaluation}
                  className={classes.evaluateButton}
                >
                  <Typography className={classes.evaluateButtonText}>
                    Avaliar
                  </Typography>
                </Button>
              </Box>
            </>
          )}

          {/* Momento 2: Confirmação pós-avaliação */}
          {!evaluationCompleted && (
            <Box className={classes.completedEvaluationContainer}>
              {/* Informações do Agendamento */}
              <Box className={classes.completedTitleGroup}>
                <Typography className={classes.completedScheduleTitle}>
                  Agendamento concluído!
                </Typography>
                <Typography className={classes.completedScheduleSubtitle}>
                  Enviamos para você um comprovante, verifique no seu e-mail.
                </Typography>
              </Box>

              <Box className={classes.completedInfoGroup}>
                {selectedDate && scheduleSelected && (
                  <Typography
                    className={classes.alertBoxDateTimeSchedule}
                    style={{ fontWeight: 600 }}
                  >
                    {typeof selectedDate?.getMonth === 'function' &&
                      format(selectedDate, 'dd/MM/yyyy')}{' '}
                    às {scheduleSelected}
                  </Typography>
                )}
                <Typography className={classes.completedScheduleSubtitle}>
                  Caso não possa comparecer, realizar o cancelamento do
                  agendamento no portal até 1h antes do horário previsto do
                  atendimento
                </Typography>
                <Alert severity="warning">
                  Não esqueça de levar os documentos solicitados no ato do
                  agendamento.
                </Alert>
              </Box>

              {/* Mensagem de Agradecimento */}
              <Box className={classes.completedThankYouGroup}>
                <Box className={classes.thankYouImageBox}>
                  <img
                    src="/assets/images/feedback-rating.svg"
                    width="100px"
                    height="100px"
                    alt="favorite"
                  />
                  <Typography className={classes.ratingTitle}>
                    Muito obrigado por contribuir!
                  </Typography>
                  <Typography className={classes.completedScheduleSubtitle}>
                    Sua opinião foi registrada!
                  </Typography>
                </Box>
              </Box>

              {/* Botões de Ação */}
              <Box className={classes.actionButtonsContainer}>
                <Button
                  id="inicio-button"
                  variant="outlined"
                  onClick={onGoToHome}
                  className={classes.outlinedButton}
                >
                  <Typography className={classes.outlinedButtonText}>
                    Voltar para o início
                  </Typography>
                </Button>
                <Button
                  id="agendamentos-button"
                  onClick={onGoToSchedules}
                  className={classes.primaryButton}
                >
                  <Typography className={classes.primaryButtonText}>
                    Meus agendamentos
                  </Typography>
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </>
  )
}
